import React from "react";

export const Modal = ({handleClose, show, children}) => {
    const showClass = show ? "modal fade show" : "modal fade";
    const showStyle = show ? {display: "block"} : {display: "none"};
    const showAria = show ? "true" : "false";
    
    return (
      <div
        className={showClass}
        id="exampleModalCenter"
        tabIndex="-1"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden={showAria}
        style={showStyle}
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ color: "#000" }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title fs-5" id="exampleModalCenterTitle">
                Sorry...
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleClose}
              ></button>
            </div>
            <div className="modal-body">
              <p className="lead fs-6 text-center">
                At the moment we are not accepting users from your
                destination. 
              </p>
            </div>
          </div>
        </div>
      </div>
    );
}